// extracted by mini-css-extract-plugin
export default {"root":"AdminAppMenu_root__68Zj8","top":"AdminAppMenu_top__iVMiQ","middle":"AdminAppMenu_middle__riSwA","bottom":"AdminAppMenu_bottom__jrq9W"};